//import { apiUrl as api_url } from "utils/helpers/enviroment.helpers";
import { fetchWithCredentials, handleErrors } from "./httpService";

const api_path = "titulares/";

export const getTitular = async (dni) => {
  try {
    const respuesta = await fetchWithCredentials(
      window.__CONFIG__.apiPrincipal + api_path + dni, 
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    await handleErrors(respuesta);
    return respuesta.json();

    // return await handleErrors(respuesta);
    // return {
    //     dni:38005464,
    //     nombre:"Lucas",
    //     apellido: "Magallanes",
    //     nombreCompleto: "Magallanes, Lucas",
    //     mail: "lucas.magallanes.94@gmail.com",
    //     telefono: "1135660145",
    //     telefonoAlternativo: "02204976233",
    //     fechaNacimiento: "06/05/1994"
    // }
  } catch (err) {
    console.error("Error", err);
    throw new Error(err.message);
  }
};

export const patchTitular = async (dni, mail, telefono, telefonoAlternativo) => {
  try {
    await fetchWithCredentials(
      window.__CONFIG__.apiPrincipal + api_path + dni,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "mail": mail,
          "telefonoCaracteristica": "",
          "telefono": telefono
        })
      }
    );
  } catch (err) {
    console.error("Error", err);
    throw new Error("Ocurrió un error al buscar al titular.");
  }
};